import PropTypes from "prop-types";
import React from "react";

import { authSpotify } from '../lib/spotify-auth';
import { getParameterByName } from '../lib/query-params';

class SpotifyAuthCallback extends React.Component {
  constructor() {
    if (getParameterByName('auto_login')) {
      authSpotify();
    }

    super();
  }

  render() {
    return (
      <React.Fragment>
        <div className="hero">
          <h2>Please login to continue</h2>
          <button className="spotify-login" onClick={() => authSpotify(true)}>Login to Spotify</button>
        </div>
        <style jsx>{`
          .hero {
            align-items: center;
            display: flex;
            flex-flow: column nowrap;
            justify-content: center;
            min-height: 45vh;
            height: 100px;
          }
          button.spotify-login {
            font-size: 1em;
            background: #84BD00;
            color: white;
            border-radius: 50px;
            width: 500px;
            min-height: 60px;
            margin-top: 50px;
            cursor: pointer;
          }
        `}</style>
      </React.Fragment>
    );
  }
}

export default SpotifyAuthCallback;



// WEBPACK FOOTER //
// ./src/pages/spotifyauth.js